import { render, staticRenderFns } from "./Submenu.vue?vue&type=template&id=c714a916&scoped=true&"
import script from "./Submenu.vue?vue&type=script&lang=js&"
export * from "./Submenu.vue?vue&type=script&lang=js&"
import style0 from "./Submenu.vue?vue&type=style&index=0&id=c714a916&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c714a916",
  null
  
)

export default component.exports